// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"16":"phoneJoin","65":"newsDetail","389":"retrievePassword","535":"login","631":"contact","697":"news","774":"emailJoin","893":"products"}[chunkId] + "." + {"16":"61409294","65":"52ebd408","389":"d43a67b7","535":"d820d012","631":"f9788647","697":"6fdb1177","774":"e35c40a5","893":"3cbbf757"}[chunkId] + ".css";
};